addEventListener("DOMContentLoaded", () => {
  const body = document.querySelector('body');
  const languageBar = document.querySelector('.language-bar');
  
  if( languageBar ) {
    const languageSwitch = languageBar.querySelector('.switcher .selected');
    const languageDropdown = languageBar.querySelector('.switcher .option');
    const languageOptions = languageDropdown.querySelectorAll('a');

    languageSwitch.addEventListener( "click", (e) => {
      
      languageDropdown.classList.toggle('open');

      // closes language dropdown when clicked outside
      body.addEventListener('click', (newEvent) => {
        if( newEvent.target != e.target ) {
          languageDropdown.classList.remove('open');
        }
      });
      
    });

    languageOptions.forEach(function (item) {
      
      item.addEventListener( 'click', (e) => {
        let lang = item.getAttribute('data-lang');
        doGTranslate('en|'+lang);
        document.querySelector('div.switcher div.selected a').innerHTML = item.innerHTML;
        return false;
      });
    });
  }

});

function GTranslateGetCurrentLang() {
  var keyValue = document['cookie'].match('(^|;) ?googtrans=([^;]*)(;|$)');
  return keyValue ? keyValue[2].split('/')[2] : null;
}

function GTranslateFireEvent(element, event) {
  try {
      if (document.createEventObject) {
          var evt = document.createEventObject();
          element.fireEvent('on' + event, evt)
      } else {
          var evt = document.createEvent('HTMLEvents');
          evt.initEvent(event, true, true);
          element.dispatchEvent(evt)
      }
  } catch (e) {}
}

function doGTranslate(lang_pair) {
  if (lang_pair.value) lang_pair = lang_pair.value;
  if (lang_pair == '') return;
  var lang = lang_pair.split('|')[1];
  if (GTranslateGetCurrentLang() == null && lang == lang_pair.split('|')[0]) return;
  var teCombo;
  var sel = document.getElementsByTagName('select');
  for (var i = 0; i < sel.length; i++)
      if (/goog-te-combo/.test(sel[i].className)) {
          teCombo = sel[i];
          break;
      } if (document.getElementById('google_translate_element2') == null || document.getElementById('google_translate_element2').innerHTML.length == 0 || teCombo.length == 0 || teCombo.innerHTML.length == 0) {
      setTimeout(function() {
          doGTranslate(lang_pair)
      }, 500)
  } else {
      teCombo.value = lang;
      GTranslateFireEvent(teCombo, 'change');
      GTranslateFireEvent(teCombo, 'change')
  }
}

if (GTranslateGetCurrentLang() != null) {
  addEventListener("DOMContentLoaded", () => {
    var lang_html = languageDropdown.querySelector('img[alt="' + GTranslateGetCurrentLang() + '"]').parentNode.innerHTML;
    if (typeof lang_html != 'undefined') {
      document.querySelector('div.switcher div.selected a').innerHTML = lang_html.replace('data-gt-lazy-', '');
    }
  });
}